import _ from "lodash"
import { fetchPortList, fetchPortListSearch } from "@/api/data"
import {planArrivaldateRange} from '@/api/customer-server'

// 全局性的通用数据
const state = {
  portList: [],
  planArrivaldateRange: null
}

// getters
const getters = {
  portMap(state) {
    let map = {}
    state.portList.forEach(v => {
      map[v.value] = v.label
    })
    return map
  }
}

// actions
const actions = {
  savePortList({ commit }) {
    // return fetchPortList().then(res => {
    //   let list = JSON.parse(_.get(res, 'data.data.value', "[]"))
    //   commit('save', {
    //     portList: list.map(v => ({
    //       label: v.name,
    //       value: v.code
    //     }))
    //   })
    // })
    return fetchPortListSearch('trailerPort').then(res => {
      // let list = JSON.parse(_.get(res, 'data.data.value', "[]"))
      let list
      if (res.data.success) list = res.data.data.map(item => {
        item.name = item.label
        item.code = item.value
        return item
      })
      commit('save', {
        portList: list.map(v => ({
          label: v.name,
          value: v.code
        }))
      })
    })
  },
  getPlanArrivaldateRange() {
    return planArrivaldateRange({}).then(res => {
      state.planArrivaldateRange = res.data.data
    })
  }
}

// mutations
const mutations = {
  save(state, payload) {
    Object.assign(state, payload)
  },
  orderListUpdate() {
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}


// WEBPACK FOOTER //
// ./src/stores/data.module.js